import { Pipe, PipeTransform } from '@angular/core';
import { IpexServiceProviderCount } from '../models/IpexServiceProviderCountModel';

@Pipe({
    name: 'getServiceProviderCount',
    standalone: true
})
export class GetServiceProviderCountPipe implements PipeTransform {
    transform(serviceProviderId: string, serviceProviderCountList: IpexServiceProviderCount[]): number {
        if (serviceProviderCountList.length === 0 || !serviceProviderId) {
            return 0;
        }

        return serviceProviderCountList?.find(item => item.serviceProviderId === serviceProviderId)?.connectedCaseCount ?? 0;
    }
}
